import type { FilteringService } from '.';

/*
This is used to populate parameters from URL.
*/
export function ConvertSaleTypes(this: FilteringService, saleTypes: string): void {
  const _saleTypes = saleTypes.split(',');

  this.includeHomesites.set(_saleTypes.includes('homesite'));
  this.includeNewHomes.set(_saleTypes.includes('new'));
  this.includePreownedHomes.set(_saleTypes.includes('preowned'));
}

/*
This is used to populate the URL parameters.
*/
export function SaleTypes(this: FilteringService): string {
  const _output: string[] = [];

  if (this.includeNewHomes()) {
    _output.push('new');
  }
  if (this.includePreownedHomes()) {
    _output.push('preowned');
  }
  if (this.includeHomesites()) {
    _output.push('homesite');
  }

  return _output.join(',');
}
